import { styled } from "@mui/material/styles";

export const PageWrapper = styled("div")(() => ({
  display: "flex",
  height: "100%",
  width: "100%",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#FCFCFD",
}));

export const ContainerFooter = styled("div")(() => ({
  position: "absolute",
  bottom: 0,
  width: "100%",
  background: "#FFF",
  boxShadow: "0px -4px 8px 0px rgba(228, 231, 236, 0.30)",
}));
